import { JsonProperty as _JsonProperty } from 'json2typescript';
import * as utils from '../core.utils';
import { AgmGlobals, DelayedJsonProperty } from '../globals';

export { JsonObject } from 'json2typescript';
export const META_ATTRS_PROPERTY = '__metadata_attributes__';

export function JsonProperty(conversionOption: any, jsonPropertyName = 'undefined'): any {
	const _jsonPropertyName = jsonPropertyName !== 'undefined' ? jsonPropertyName : undefined;
	const f = _JsonProperty.prototype.constructor(_jsonPropertyName, conversionOption, true);
	return (target: any, classPropertyName: string) => {
		const attrs = target[META_ATTRS_PROPERTY] = target[META_ATTRS_PROPERTY] || [];
		attrs.push(classPropertyName);
		f(target, classPropertyName);
	};
}

// TODO redesign exclude class name
export function JsonDelayedProperty(className: string, conversionOption: string, jsonPropertyName = 'undefined'): any {
	const _jsonPropertyName = jsonPropertyName !== 'undefined' ? jsonPropertyName : undefined;
	const f = _JsonProperty.prototype.constructor(_jsonPropertyName, conversionOption, true);

	return (target: any, classPropertyName: string) => {
		const attrs = target[META_ATTRS_PROPERTY] = target[META_ATTRS_PROPERTY] || [];
		attrs.push(classPropertyName);

		const agmGlobals = utils.getGlobals();
		agmGlobals.delayedJsonProperties.push({
			className,
			target,
			classPropertyName,
			jsonPropertyName: _jsonPropertyName,
			conversionOption
		} as DelayedJsonProperty);
	};
}

export function injectJsonDelayedProperty(): void {
	const agmGlobals = utils.getGlobals();
	const jsonClasses = {};
	agmGlobals.delayedJsonProperties.forEach(jsonProperty => {
		if (!jsonClasses[jsonProperty.className]) {
			jsonClasses[jsonProperty.className] = jsonProperty.target.constructor;
		}
	});

	agmGlobals.delayedJsonProperties.forEach(jsonProperty => {
		const co = jsonProperty.conversionOption;

		if (typeof co !== 'string') {
			return
		}
		let isArray = false;

		if (co === 'Object') {
			return;
		}

		if (co.startsWith('[')) {
			jsonProperty.conversionOption = jsonClasses[co.substr(1, co.length - 2)];
			isArray = true;
		}
		else {
			jsonProperty.conversionOption = jsonClasses[jsonProperty.conversionOption];
		}

		if (!jsonProperty.conversionOption) {
			throw new Error(
				`${co} not found in delaied json classes for ${jsonProperty.target}`
			);
		}

		if (isArray) {
			jsonProperty.conversionOption = [jsonProperty.conversionOption];
		}

		const f = _JsonProperty.prototype.constructor(jsonProperty.jsonPropertyName, jsonProperty.conversionOption, true);
		f(jsonProperty.target, jsonProperty.classPropertyName);
	});
}